/** Reserva uma única tentativa de recuperação por aba, sem falhar se o storage estiver bloqueado. */
export function claimRecoveryAttempt(key: string): boolean {
  try {
    if (typeof window === "undefined" || window.sessionStorage.getItem(key)) return false;
    window.sessionStorage.setItem(key, "1");
    return true;
  } catch {
    // Sem persistência não é possível garantir proteção contra loops de reload.
    return false;
  }
}
